import React, { useEffect, useState } from 'react'
import { FaMinusCircle, FaPlusCircle, FaTrash, FaShoppingCart,
   FaUser, FaTag, FaRupeeSign, FaPercent, FaWallet, 
   FaMoneyBillWave, FaCalculator, FaReceipt } from 'react-icons/fa'
import { useStateContext } from '../Context/ContextProvider'
import axios from 'axios';

import Swal from 'sweetalert2';
import Puff from 'react-loading-icons/dist/esm/components/puff';

function BillDetail() {
    const { items, setItems, userId } = useStateContext();
    const stringitems = JSON.parse(items);

    const [entercash, setEntercash] = useState('');
    const [discount, setDiscount] = useState(0);
    const [extra_discount, setextra_discount] = useState(0);
    const [pBlanace, setPbalance] = useState(0);
    const [grandTotal, setGrandTotal] = useState(0);
    const [selectedOptionsector, setSelectedOptionsector] = useState(0);
    const [selectedOptionshop, setSelectedOptionshop] = useState(0);
    const [subsectors, setsubsectors] = useState(null);
    const [shopId, setShopId] = useState(0);
    const [sectors, setsectors] = useState([]);
    const [shop, setshop] = useState([]);
    const [ppadvance, setPPadvance] = useState(0);
    const [recovery, setRecovery] = useState(0);
    const [remaining, setRemaining] = useState(0);
    const [loading, setLoading] = useState(false);
    const [isDiscountUpdating, setIsDiscountUpdating] = useState(false);
    const [salesTax, setSalesTax] = useState(18);
    const [salesTaxAmount, setSalesTaxAmount] = useState(0);
  

    const handleSaveReciept = (e) => {
        setLoading(true);
        e.preventDefault();
        const data = {
            letter: stringitems,
            sector: selectedOptionsector,
            subsector: selectedOptionshop,
            ppcell: shopId,
            manualdate: getToday(),
            recovery: recovery,
            ppadvance: ppadvance,
            salesmanid: userId,
            sales_tex_percent: salesTax,
            salesTaxAmount: salesTaxAmount,
            supergrandtotal: grandTotal,
            discount: discount,
            extra_discount: extra_discount,
        }

        if (data.letter.length > 0 && data.ppcell !== 0 && data.manualdate ? data.manualdate.length > 0 : 0) {
            axios.post('/api/post/reciept/entrysale', data).then(res => {
                if (res.data.msg === '0') {
                    Swal.fire({
                        position: 'center',
                        icon: 'warning',
                        title: 'Day has been closed',
                        showConfirmButton: false,
                        timer: 1500
                    })
                    setLoading(false);
                    return false;
                } else {
                    setItems([]);
                    setGrandTotal(0);
                    setEntercash(0);
                    setDiscount(0);
                    setSalesTaxAmount(0);
                    setSalesTax(0);
                    setLoading(false);
                    Swal.fire({
                        position: 'center',
                        icon: 'success',
                        title: 'Saved',
                        showConfirmButton: false,
                        timer: 1500
                    })
                }
            });
        } else {
            Swal.fire({
                position: 'top-end',
                icon: 'info',
                title: 'Fill All Fields',
                showConfirmButton: false,
                timer: 1500
            })
            setLoading(false);
        }
    }

    const sethandleSalesTax = (e) => {
        setSalesTax(e.target.value);
        setSalesTaxAmount(0);
    }

    const handleDiscount = (e) => {
        e.preventDefault();
        const updatedDiscount = parseFloat(e.target.value);
        setIsDiscountUpdating(true);
        setDiscount(updatedDiscount);
    }

    const handleEntercash = (e) => {
        e.preventDefault();
        setEntercash(e.target.value);
    }

    useEffect(() => {
        const data = {
            id: shopId,
            salesman_id: userId
        }
        if (shopId > 0) {
            axios.post('/api/shopkeeper/pbalance', data).then(res => {
                setPbalance(res.data.pbalance);
                setSalesTax(parseFloat(res.data.salesTax));
            });
        } else {
            setPbalance(0);
        }
    }, [shopId, stringitems, userId])

    const fetchPbalance = (event) => {
        event.preventDefault();
        setShopId(event.target.value);
    }

    useEffect(() => {
        axios.get('/sanctum/csrf-cookie').then(response => {
            axios.get(`/api/getsectors`).then(res => {
                setsectors(res.data.sectors);
                setSelectedOptionsector(res.data.sectors[0]['id']);
            });
        });
    }, []);

    useEffect(() => {
        if (selectedOptionsector) {
            axios.get(`/api/getsubsectors/${selectedOptionsector}`)
                .then(response => {
                    setsubsectors(response.data.subsectors);
                })
                .catch(error => {
                    console.error(error);
                });
        }
    }, [selectedOptionsector]);

    useEffect(() => {
        if (selectedOptionshop) {
            axios.get(`/api/getshop/${selectedOptionshop}`)
                .then(response => {
                    const sortedShpos = [...response.data.shop].sort((a, b) => a.name.localeCompare(b.name));
                    setshop(sortedShpos);
                })
                .catch(error => {
                    console.error(error);
                });
        }
    }, [selectedOptionshop])

    useEffect(() => {
        if (stringitems !== null) {
            const sumgrandtotal = stringitems.reduce((acc, item) => {
                const value = parseFloat(item.unitsaleprice * item.qty);
                return isNaN(value) ? acc : acc + value;
            }, 0);
            setGrandTotal(sumgrandtotal.toFixed(2));

            const totaldiscount = stringitems.reduce((acc, item) => {
                const value = parseFloat(item.subtotaldiscount);
                return isNaN(value) ? acc : acc + value;
            }, 0);
            if (!isDiscountUpdating) {
                setDiscount(parseFloat(totaldiscount).toFixed(2));
            }
            const totalextradiscount = stringitems.reduce((acc, item) => {
                const value = parseFloat(item.extra_discount * item.qty);
                return isNaN(value) ? acc : acc + value;
            }, 0);
            setextra_discount(totalextradiscount);
            setSalesTaxAmount(parseFloat((sumgrandtotal - discount) * salesTax / 100), 4);
        }
    }, [stringitems, isDiscountUpdating, salesTaxAmount, setDiscount, salesTax, discount]);

    useEffect(() => {
        const cashenter = entercash === '' ? 0 : entercash;
        if (parseFloat(cashenter) > (parseFloat(grandTotal) - parseFloat(discount) + parseFloat(salesTaxAmount))) {
            const afterdiscount = parseFloat(pBlanace) + parseFloat(grandTotal) - parseFloat(cashenter) - parseFloat(discount) + parseFloat(salesTaxAmount);
            setRemaining(afterdiscount);
            setPPadvance((parseFloat(grandTotal) - parseFloat(discount) + parseFloat(salesTaxAmount)).toFixed(2));
            setRecovery((parseFloat(cashenter) - (parseFloat(grandTotal) - parseFloat(discount) + parseFloat(salesTaxAmount))).toFixed(2));
        } else {
            const afterdiscount = parseFloat(pBlanace) + parseFloat(grandTotal) - parseFloat(cashenter) - parseFloat(discount) + parseFloat(salesTaxAmount);
            setRemaining(afterdiscount.toFixed(2));
            setPPadvance(parseFloat(cashenter));
            setRecovery(0);
        }
    }, [entercash, pBlanace, discount, stringitems, grandTotal, salesTaxAmount]);

    function getToday() {
        const today = new Date();
        const year = today.getFullYear();
        let month = today.getMonth() + 1;
        let day = today.getDate();
        month = month < 10 ? `0${month}` : month;
        day = day < 10 ? `0${day}` : day;
        return `${year}-${month}-${day}`;
    }

    const handleSubTotalDiscount = (id, event) => {
        const newItems = [...stringitems];
        const index = newItems.findIndex(item => item.id === id);
        newItems[index].subtotaldiscount = event.target.value;
        const discountvalue = event.target.value;
        newItems[index].discountpercent = discountvalue;
        setItems(newItems);
    }

    const handleUnitSalePriceChange = (id, event) => {
        const newItems = [...stringitems];
        const index = newItems.findIndex(item => item.id === id);
        newItems[index].unitsaleprice = event.target.value;
        const subtotaldis = (newItems[index].qty * newItems[index].unitsaleprice) * newItems[index].discountpercent / 100;
        newItems[index].subtotaldiscount = parseFloat(subtotaldis).toFixed(2);
        newItems[index].grandtotal = parseFloat((newItems[index].qty * newItems[index].unitsaleprice) - (subtotaldis)).toFixed(2);
        setItems(newItems);
    };

    const handleRemove = (id) => {
        setItems(stringitems.filter((item) => item.id !== id));
    };

    const handleQtyIncre = (id) => {
        const newItems = [...stringitems];
        const index = newItems.findIndex(item => item.id === id);
        newItems[index].qty = parseFloat(newItems[index].qty) + 1;
        newItems[index].subtotaldiscount = (newItems[index].qty * newItems[index].discountpercent);
        if (newItems[index].remaining >= newItems[index].qty) {
            setItems(newItems);
        } else {
            Swal.fire({
                position: 'top-end',
                icon: 'error',
                title: 'Store Does Not Have Enough Items',
                showConfirmButton: false,
                timer: 1500
            })
        }
    };

    const handleQtyDec = (id) => {
        const newItems = [...stringitems];
        const index = newItems.findIndex(item => item.id === id);
        newItems[index].qty = newItems[index].qty - 1;
        newItems[index].subtotaldiscount = (newItems[index].qty * newItems[index].discountpercent);
        if (newItems[index].qty > 0) {
            setItems(newItems);
        } else {
            Swal.fire({
                position: 'top-end',
                icon: 'error',
                title: 'Not Allowed Below 1',
                showConfirmButton: false,
                timer: 1500
            })
        }
    };

    const totalItems = stringitems ? stringitems.length : 0;

    return (
        <div className="bill-container">
            <style>{`
                .bill-container {
                    max-width: 480px;
                    margin: 0 auto;
                    background: #f5f7fa;
                    min-height: 100vh;
                    padding: 12px 12px 90px 12px;
                    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
                }

                /* Header */
                .bill-header {
                    background: linear-gradient(135deg, #4a6cf7, #6b4cf7);
                    border-radius: 16px;
                    padding: 16px 20px;
                    margin-bottom: 16px;
                    color: white;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                }

                .bill-header-title {
                    font-size: 18px;
                    font-weight: 700;
                    display: flex;
                    align-items: center;
                    gap: 10px;
                }

                .bill-header-badge {
                    background: rgba(255,255,255,0.2);
                    padding: 4px 12px;
                    border-radius: 50px;
                    font-size: 12px;
                    font-weight: 600;
                }

                /* Select Section */
                .select-section {
                    background: white;
                    border-radius: 16px;
                    padding: 16px;
                    margin-bottom: 16px;
                    box-shadow: 0 2px 8px rgba(0,0,0,0.04);
                    border: 1px solid #e9ecef;
                }

                .select-grid {
                    display: grid;
                    grid-template-columns: 1fr 1fr 1fr;
                    gap: 8px;
                }

                .select-grid select {
                    width: 100%;
                    padding: 10px 8px;
                    border: 2px solid #e9ecef;
                    border-radius: 10px;
                    font-size: 13px;
                    background: white;
                    outline: none;
                    transition: all 0.3s ease;
                    -webkit-appearance: none;
                    appearance: none;
                    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%237a8a9e' d='M6 8L1 3h10z'/%3E%3C/svg%3E");
                    background-repeat: no-repeat;
                    background-position: right 10px center;
                }

                .select-grid select:focus {
                    border-color: #4a6cf7;
                    box-shadow: 0 0 0 3px rgba(74, 108, 247, 0.1);
                }

                .select-grid select option {
                    padding: 8px;
                }

                /* Cart Items */
                .cart-items {
                    display: flex;
                    flex-direction: column;
                    gap: 8px;
                    margin-bottom: 16px;
                }

                .cart-item {
                    background: white;
                    border-radius: 14px;
                    padding: 12px 14px;
                    box-shadow: 0 2px 8px rgba(0,0,0,0.04);
                    border: 1px solid #e9ecef;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    gap: 10px;
                }

                .cart-item-info {
                    flex: 1;
                    min-width: 0;
                }

                .cart-item-name {
                    font-size: 13px;
                    font-weight: 600;
                    color: #1a2332;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }

                .cart-item-details {
                    display: flex;
                    gap: 12px;
                    margin-top: 4px;
                    flex-wrap: wrap;
                }

                .cart-item-detail {
                    font-size: 12px;
                    color: #7a8a9e;
                    display: flex;
                    align-items: center;
                    gap: 4px;
                }

                .cart-item-detail input {
                    width: 70px;
                    padding: 4px 6px;
                    border: 1.5px solid #e9ecef;
                    border-radius: 6px;
                    font-size: 12px;
                    outline: none;
                    transition: all 0.3s ease;
                }

                .cart-item-detail input:focus {
                    border-color: #4a6cf7;
                    box-shadow: 0 0 0 3px rgba(74, 108, 247, 0.1);
                }

                .cart-item-actions {
                    display: flex;
                    align-items: center;
                    gap: 6px;
                }

                .cart-item-qty {
                    font-weight: 700;
                    font-size: 16px;
                    color: #1a2332;
                    min-width: 24px;
                    text-align: center;
                }

                .cart-item-total {
                    font-size: 14px;
                    font-weight: 700;
                    color: #4a6cf7;
                    min-width: 70px;
                    text-align: right;
                }

                .action-icon {
                    font-size: 24px;
                    cursor: pointer;
                    transition: all 0.2s ease;
                    padding: 4px;
                    border-radius: 8px;
                }

                .action-icon:active {
                    transform: scale(0.9);
                }

                .action-icon-plus {
                    color: #2ecc71;
                }

                .action-icon-plus:hover {
                    background: rgba(46, 204, 113, 0.1);
                }

                .action-icon-minus {
                    color: #f39c12;
                }

                .action-icon-minus:hover {
                    background: rgba(243, 156, 18, 0.1);
                }

                .action-icon-trash {
                    color: #ff4757;
                    font-size: 18px;
                }

                .action-icon-trash:hover {
                    background: rgba(255, 71, 87, 0.1);
                }

                /* Summary */
                .summary-section {
                    background: white;
                    border-radius: 16px;
                    padding: 16px;
                    margin-bottom: 16px;
                    box-shadow: 0 2px 8px rgba(0,0,0,0.04);
                    border: 1px solid #e9ecef;
                }

                .summary-title {
                    font-size: 14px;
                    font-weight: 700;
                    color: #1a2332;
                    margin-bottom: 12px;
                    display: flex;
                    align-items: center;
                    gap: 8px;
                }

                .summary-row {
                    display: flex;
                    justify-content: space-between;
                    padding: 6px 0;
                    font-size: 13px;
                    border-bottom: 1px solid #f1f3f5;
                }

                .summary-row:last-child {
                    border-bottom: none;
                }

                .summary-label {
                    color: #7a8a9e;
                    display: flex;
                    align-items: center;
                    gap: 6px;
                }

                .summary-value {
                    font-weight: 600;
                    color: #1a2332;
                }

                .summary-value.highlight {
                    color: #4a6cf7;
                }

                .summary-value.amount {
                    color: #2ecc71;
                }

                .summary-input {
                    width: 80px;
                    padding: 4px 8px;
                    border: 1.5px solid #e9ecef;
                    border-radius: 6px;
                    font-size: 13px;
                    outline: none;
                    text-align: right;
                    transition: all 0.3s ease;
                }

                .summary-input:focus {
                    border-color: #4a6cf7;
                    box-shadow: 0 0 0 3px rgba(74, 108, 247, 0.1);
                }

                /* Tax & Cash */
                .input-section {
                    background: white;
                    border-radius: 16px;
                    padding: 16px;
                    margin-bottom: 16px;
                    box-shadow: 0 2px 8px rgba(0,0,0,0.04);
                    border: 1px solid #e9ecef;
                }

                .input-section label {
                    font-size: 13px;
                    font-weight: 600;
                    color: #1a2332;
                    display: flex;
                    align-items: center;
                    gap: 8px;
                    margin-bottom: 6px;
                }

                .input-section input {
                    width: 100%;
                    padding: 10px 12px;
                    border: 2px solid #e9ecef;
                    border-radius: 10px;
                    font-size: 15px;
                    outline: none;
                    transition: all 0.3s ease;
                }

                .input-section input:focus {
                    border-color: #4a6cf7;
                    box-shadow: 0 0 0 3px rgba(74, 108, 247, 0.1);
                }

                /* Save Button */
                .save-btn {
                    width: 100%;
                    padding: 14px;
                    border: none;
                    border-radius: 14px;
                    font-size: 16px;
                    font-weight: 700;
                    color: white;
                    background: linear-gradient(135deg, #2ecc71, #27ae60);
                    transition: all 0.3s ease;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    gap: 10px;
                    box-shadow: 0 4px 16px rgba(46, 204, 113, 0.3);
                }

                .save-btn:active {
                    transform: scale(0.97);
                }

                .save-btn:disabled {
                    opacity: 0.6;
                    cursor: not-allowed;
                }

                .save-btn svg {
                    font-size: 20px;
                }

                /* Empty Cart */
                .empty-cart {
                    text-align: center;
                    padding: 40px 20px;
                    color: #7a8a9e;
                }

                .empty-cart svg {
                    font-size: 48px;
                    color: #e9ecef;
                    margin-bottom: 12px;
                }

                .empty-cart h3 {
                    color: #1a2332;
                    margin-bottom: 4px;
                }

                /* Badge */
                .badge-count {
                    background: #ff4757;
                    color: white;
                    font-size: 10px;
                    font-weight: 700;
                    padding: 2px 8px;
                    border-radius: 50px;
                    margin-left: 6px;
                }

                /* Responsive */
                @media (max-width: 576px) {
                    .bill-container {
                        padding: 8px 8px 80px 8px;
                    }
                    .select-grid {
                        grid-template-columns: 1fr;
                        gap: 6px;
                    }
                    .cart-item {
                        flex-wrap: wrap;
                        padding: 10px 12px;
                    }
                    .cart-item-info {
                        width: 100%;
                    }
                    .cart-item-actions {
                        width: 100%;
                        justify-content: space-between;
                    }
                    .cart-item-total {
                        min-width: 60px;
                    }
                    .summary-row {
                        font-size: 12px;
                        padding: 4px 0;
                    }
                    .summary-input {
                        width: 60px;
                        font-size: 12px;
                    }
                }

                @media (max-width: 400px) {
                    .bill-header {
                        padding: 12px 16px;
                    }
                    .bill-header-title {
                        font-size: 16px;
                    }
                    .cart-item-detail input {
                        width: 55px;
                    }
                }
            `}</style>

            {/* Header */}
            <div className="bill-header">
                <div className="bill-header-title">
                    <FaReceipt />
                    Bill Detail
                </div>
                <div className="bill-header-badge">
                    <FaShoppingCart /> {totalItems} items
                </div>
            </div>

            {/* Customer Selection */}
            <div className="select-section">
                <div className="select-grid">
                    <select onChange={e => setSelectedOptionsector(e.target.value)} value={selectedOptionsector}>
                        <option>Select Sector</option>
                        {sectors.map(({ id, name }) => (
                            <option key={id} value={id}>{name}</option>
                        ))}
                    </select>
                    <select onChange={e => setSelectedOptionshop(e.target.value)} value={selectedOptionshop}>
                        <option>SubSector</option>
                        {subsectors && subsectors.map(item => (
                            <option key={item.id} value={item.id}>{item.name}</option>
                        ))}
                    </select>
                    <select onChange={fetchPbalance}>
                        <option>Customer</option>
                        {shop && shop.map(item => (
                            <option key={item.user_id} value={item.user_id}>{item.name}</option>
                        ))}
                    </select>
                </div>
            </div>

            {/* Cart Items */}
            {stringitems && stringitems.length > 0 ? (
                <div className="cart-items">
                    {stringitems.map((item) => (
                        <div className="cart-item" key={item.id}>
                            <div className="cart-item-info">
                                <div className="cart-item-name">{item.name}</div>
                                <div className="cart-item-details">
                                    <span className="cart-item-detail">
                                        <FaRupeeSign size={10} />
                                        <input value={item.unitsaleprice} onChange={(e) => handleUnitSalePriceChange(item.id, e)} />
                                    </span>
                                    <span className="cart-item-detail">
                                        <FaPercent size={10} />
                                        <input value={item.subtotaldiscount} onChange={(e) => handleSubTotalDiscount(item.id, e)} />
                                    </span>
                                    <span className="cart-item-detail">
                                        <FaTrash className="action-icon-trash" onClick={(e) => handleRemove(item.id)} />
                                    </span>
                                </div>
                            </div>
                            <div className="cart-item-actions">
                                <FaMinusCircle className="action-icon action-icon-minus" onClick={() => handleQtyDec(item.id)} />
                                <span className="cart-item-qty">{item.qty}</span>
                                <FaPlusCircle className="action-icon action-icon-plus" onClick={() => handleQtyIncre(item.id)} />
                            </div>
                            <div className="cart-item-total">
                                {parseFloat(item.unitsaleprice * item.qty).toFixed(2)}
                            </div>
                        </div>
                    ))}
                </div>
            ) : (
                <div className="empty-cart">
                    <FaShoppingCart />
                    <h3>Cart is Empty</h3>
                    <p>Add items from the product list</p>
                </div>
            )}

            {/* Summary */}
            <div className="summary-section">
                <div className="summary-title">
                    <FaCalculator /> Summary
                </div>
                <div className="summary-row">
                    <span className="summary-label"><FaRupeeSign /> Grand Total</span>
                    <span className="summary-value">{grandTotal}</span>
                </div>
                <div className="summary-row">
                    <span className="summary-label"><FaPercent /> Discount</span>
                    <input className="summary-input" type='number' value={discount} name='discount' onChange={handleDiscount} />
                </div>
                <div className="summary-row">
                    <span className="summary-label">After Discount</span>
                    <span className="summary-value highlight">{parseFloat(grandTotal - discount).toFixed(2)}</span>
                </div>
                <div className="summary-row">
                    <span className="summary-label"><FaTag /> Sales Tax</span>
                    <span className="summary-value highlight">{parseFloat(salesTaxAmount).toFixed(2)}</span>
                </div>
                <div className="summary-row">
                    <span className="summary-label"><FaWallet /> Net Amount</span>
                    <span className="summary-value amount">{parseFloat(grandTotal - discount + salesTaxAmount).toFixed(2)}</span>
                </div>
                <div className="summary-row">
                    <span className="summary-label"><FaUser /> Pre Balance</span>
                    <span className="summary-value">{parseFloat(pBlanace).toFixed(2)}</span>
                </div>
                <div className="summary-row">
                    <span className="summary-label"><FaMoneyBillWave /> Recovery</span>
                    <span className="summary-value">{parseFloat(recovery).toFixed(2)}</span>
                </div>
                <div className="summary-row">
                    <span className="summary-label">Total Payment</span>
                    <span className="summary-value">{parseFloat(entercash === '' ? 0 : entercash).toFixed(2)}</span>
                </div>
                <div className="summary-row" style={{ borderTop: '2px solid #4a6cf7', paddingTop: '8px', marginTop: '4px' }}>
                    <span className="summary-label" style={{ fontWeight: '700', color: '#1a2332' }}>Remaining</span>
                    <span className="summary-value" style={{ color: parseFloat(remaining) > 0 ? '#ff4757' : '#2ecc71', fontWeight: '700' }}>
                        {parseFloat(parseFloat(remaining)).toFixed(2)}
                    </span>
                </div>
            </div>

            {/* Tax & Cash */}
            <div className="input-section">
                <label><FaPercent /> Adv. Tax</label>
                <input type='number' value={salesTax} onChange={sethandleSalesTax} placeholder="Enter tax percentage" />
            </div>

            <div className="input-section">
                <label><FaMoneyBillWave /> Enter Cash</label>
                <input type='number' value={entercash} onChange={handleEntercash} placeholder="Enter cash amount" />
            </div>

            {/* Save Button */}
            <button className="save-btn" onClick={handleSaveReciept} disabled={loading || !stringitems || stringitems.length === 0}>
                {loading ? <Puff stroke="#ffffff" height={26} width={30} speed={0.75} /> : <><FaReceipt /> Save Receipt</>}
            </button>
        </div>
    )
}

export default BillDetail